// Smooth-scroll to a section by id, then re-correct a few times as below-fold
// images (galleries, doctor cards) finish loading and shift the layout.
// Without the correction, long pages compute the target Y before images load
// and land short of sections near the bottom (e.g. testimonials/reviews).
export default function scrollToSection(id) {
  const target = String(id).replace(/^#/, '');
  if (!target) return;
  const go = () => {
    const el = document.getElementById(target);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  go();
  let n = 0;
  const fix = () => {
    go();
    if (++n < 3) setTimeout(fix, 350);
  };
  setTimeout(fix, 350);
}
